import React from 'react';
import AiMark from './AiMark';

// The Information Hub's "pin frame" (9-22 mockups, refined 9-30): a black
// frame with the AI pentagon sitting inside it below a small gap, the title
// beside the pentagon, and a connector that drops from the pentagon's bottom
// point before turning right to run under the title as a rule.
//
// Used by the ribbon-only stub pages and the Report ("Loop us in" / "Will
// investigate") screens. `corner` renders inside the frame's top-right (the
// intake forms' close button); `className` extends the frame itself.

// AiMark's pin is 76px wide, so its bottom point is 38px in from its left edge.
const PIN_TIP_OFFSET = 'ml-[38px]';

const PinFrame = ({ title, corner = null, className = '', children }) => (
  <div className={`relative border-2 border-black mt-10 px-10 pt-6 pb-12 ${className}`}>
    {corner}
    <div className="flex items-end gap-8">
      <AiMark variant="pin" />
      <h1 className="text-3xl font-bold text-[#1B3A5F] pb-2 mb-0">{title}</h1>
    </div>
    {/* Vertical stem from the pin's point, then the rule branching right. */}
    <div className={`h-4 border-l border-black ${PIN_TIP_OFFSET}`} />
    <div className={`border-t border-black mr-8 ${PIN_TIP_OFFSET}`} />
    <div className="mt-8">{children}</div>
  </div>
);

export default PinFrame;
